import { AxiosError } from 'axios';
import { ErrorCode } from '../types.js';

const AxiosErrorCodeToVrioOttErrorCode = {
  [AxiosError.ERR_BAD_OPTION_VALUE]: ErrorCode.IMPOSSIBLE_TO_CREATE_REQUEST,
  [AxiosError.ERR_BAD_OPTION]: ErrorCode.IMPOSSIBLE_TO_CREATE_REQUEST,
  [AxiosError.ECONNABORTED]: ErrorCode.REQUEST_TIMEOUT,
  [AxiosError.ETIMEDOUT]: ErrorCode.REQUEST_TIMEOUT,
  [AxiosError.ERR_FR_TOO_MANY_REDIRECTS]: ErrorCode.UNEXPECTED_ERROR,
  [AxiosError.ERR_DEPRECATED]: ErrorCode.IMPOSSIBLE_TO_CREATE_REQUEST,
  [AxiosError.ERR_BAD_RESPONSE]: ErrorCode.OTHER_HTTP_ERROR,
  [AxiosError.ERR_BAD_REQUEST]: ErrorCode.OTHER_HTTP_ERROR,
  [AxiosError.ERR_CANCELED]: ErrorCode.OTHER_HTTP_ERROR,
  [AxiosError.ERR_NOT_SUPPORT]: ErrorCode.OTHER_HTTP_ERROR,
  [AxiosError.ERR_INVALID_URL]: ErrorCode.IMPOSSIBLE_TO_CREATE_REQUEST
};
function getErrorCodeFromAxiosErrorCode(axiosErrorCode, { isConnected }) {
  if (axiosErrorCode === AxiosError.ERR_NETWORK) {
    return (isConnected?.() ?? true) === false ? ErrorCode.LOST_INTERNET_CONNECTION : ErrorCode.OTHER_HTTP_ERROR;
  }
  return AxiosErrorCodeToVrioOttErrorCode[axiosErrorCode];
}
function getErrorCodeFromAxiosError(error, options) {
  return error.response && error.config?.getErrorCode?.(error) || getErrorCodeFromAxiosErrorCode(error.code, options) || ErrorCode.UNEXPECTED_ERROR;
}

export { getErrorCodeFromAxiosError };
//# sourceMappingURL=utils.js.map
